import { render, staticRenderFns } from "./temporaryDonorRegistration.vue?vue&type=template&id=a488dc40&scoped=true"
import script from "./temporaryDonorRegistration.vue?vue&type=script&lang=js"
export * from "./temporaryDonorRegistration.vue?vue&type=script&lang=js"
import style0 from "./temporaryDonorRegistration.vue?vue&type=style&index=0&id=a488dc40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a488dc40",
  null
  
)

export default component.exports